module.exports = __webpack_public_path__ + "static/media/rwrc_logo.c88f0c47.png";